import { useUrl } from '@/hooks/useUrl';
import { Button } from '@mui/material';
import { Box } from '@mui/system';
import { type FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

type NavigationRoutes = 'builder' | 'analytics' | 'comparer';

const routes: { destination: NavigationRoutes; label: string }[] = [
  { destination: 'builder', label: 'Builder' },
  { destination: 'analytics', label: 'Analytics' },
  { destination: 'comparer', label: 'Comparer' }
];

const NavigationButtons: FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { savedUrl, setSavedUrl } = useUrl();

  const isCurrent = (destination: NavigationRoutes) => location.pathname.startsWith(`/${destination}`);

  const handleNavigation = (destination: NavigationRoutes) => {
    if (location.pathname === `/${destination}`) {
      return;
    }

    if (location.pathname.startsWith('/analytics')) {
      setSavedUrl(location.search);
    }

    switch (destination) {
      case 'builder':
        navigate('/builder');
        break;
      case 'analytics':
        navigate('/analytics' + savedUrl);
        break;
      case 'comparer':
        navigate('/comparer');
        break;

      default:
        break;
    }
  };

  return (
    <Box display={'flex'} gap={1}>
      {routes.map(({ destination, label }) => (
        <Button
          key={destination}
          variant='contained'
          color={isCurrent(destination) ? 'primary' : 'inherit'}
          onClick={() => handleNavigation(destination)}
        >
          {label}
        </Button>
      ))}
    </Box>
  );
};

export default NavigationButtons;
